import { render, staticRenderFns } from "./PythonGist.vue?vue&type=template&id=7f10a190&scoped=true&"
import script from "./PythonGist.vue?vue&type=script&lang=js&"
export * from "./PythonGist.vue?vue&type=script&lang=js&"
import style0 from "./PythonGist.vue?vue&type=style&index=0&id=7f10a190&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f10a190",
  null
  
)

export default component.exports